// extracted by mini-css-extract-plugin
module.exports = {"item":"EntityItem_item__7WEs5","infos":"EntityItem_infos__n0e3l"};